export class Restaurant {
  constructor(data = {}) {
    this.id = data.id || '';
    this.alias = data.alias || '';
    this.name = data.name || '';
    this.imageUrl = data.imageUrl || '';
    this.isClosed = data.isClosed || false;
    this.url = data.url || '';
    this.reviewCount = data.reviewCount || 0;
    this.categories = (data.categories || []).map(cat => new Restaurant.Category(cat));
    this.rating = data.rating || 0;
    this.coordinates = data.coordinates ? new Restaurant.Coordinates(data.coordinates) : null;
    this.transactions = data.transactions || [];
    this.price = data.price || '';
    this.location = data.location ? new Restaurant.Location(data.location) : null;
    this.phone = data.phone || '';
    this.displayPhone = data.displayPhone || '';
    this.distance = data.distance || 0;
  }

  // Helper method to get rating display
  getRatingDisplay() {
    if (this.rating < 0.5) return '0';
    if (this.rating < 1.5) return '1';
    if (this.rating < 2.5) return '2';
    if (this.rating < 3.5) return '3';
    if (this.rating < 4.5) return '4';
    return '5';
  }

  // Helper method to get formatted address
  getFormattedAddress() {
    if (!this.location) return '';
    return this.location.displayAddress?.join(', ') || '';
  }

  // Helper method to get price display
  getPriceDisplay() {
    return this.price || '';
  }

  // Helper method to get categories display
  getCategoriesDisplay() {
    return this.categories.map(cat => cat.title).join(', ');
  }

  // Static inner classes
  static Category = class {
    constructor(data = {}) {
      this.alias = data.alias || '';
      this.title = data.title || '';
    }
  };

  static Coordinates = class {
    constructor(data = {}) {
      this.latitude = data.latitude || 0;
      this.longitude = data.longitude || 0;
    }
  };

  static Location = class {
    constructor(data = {}) {
      this.address1 = data.address1 || '';
      this.address2 = data.address2 || '';
      this.address3 = data.address3 || '';
      this.city = data.city || '';
      this.zipCode = data.zipCode || '';
      this.country = data.country || '';
      this.state = data.state || '';
      this.displayAddress = data.display_address || [];
    }
  };

  static getRatingImage(rating) {
    if (rating < 0.5) {
      return '/images/small_16/Review_Ribbon_small_16_0@1x.png';
    } else if (rating < 1.0) {
      // Special case: use rating_1 for 0.5 stars since we don't have a half-star image
      return '/images/small_16/Review_Ribbon_small_16_1@1x.png';
    } else if (rating < 1.5) {
      return '/images/small_16/Review_Ribbon_small_16_1@1x.png';
    } else if (rating < 2.0) {
      return '/images/small_16/Review_Ribbon_small_16_2_half@1x.png';
    } else if (rating < 2.5) {
      return '/images/small_16/Review_Ribbon_small_16_2@1x.png';
    } else if (rating < 3.0) {
      return '/images/small_16/Review_Ribbon_small_16_2_half@1x.png';
    } else if (rating < 3.5) {
      return '/images/small_16/Review_Ribbon_small_16_3@1x.png';
    } else if (rating < 4.0) {
      return '/images/small_16/Review_Ribbon_small_16_3_half@1x.png';
    } else if (rating < 4.5) {
      return '/images/small_16/Review_Ribbon_small_16_4@1x.png';
    } else if (rating < 5.0) {
      return '/images/small_16/Review_Ribbon_small_16_4_half@1x.png';
    } else {
      return '/images/small_16/Review_Ribbon_small_16_5@1x.png';
    }
  }

  // Convert to plain object for Firestore
  toMap() {
    return {
      id: this.id,
      alias: this.alias,
      name: this.name,
      imageUrl: this.imageUrl,
      isClosed: this.isClosed,
      url: this.url,
      reviewCount: this.reviewCount,
      categories: this.categories.map(cat => ({
        alias: cat.alias,
        title: cat.title
      })),
      rating: this.rating,
      coordinates: this.coordinates ? {
        latitude: this.coordinates.latitude,
        longitude: this.coordinates.longitude
      } : null,
      transactions: this.transactions,
      price: this.price,
      location: this.location ? {
        address1: this.location.address1,
        address2: this.location.address2,
        address3: this.location.address3,
        city: this.location.city,
        zipCode: this.location.zipCode,
        country: this.location.country,
        state: this.location.state,
        displayAddress: this.location.displayAddress
      } : null,
      phone: this.phone,
      displayPhone: this.displayPhone,
      distance: this.distance
    };
  }

  // Convert to JSON string
  toJSON() {
    return JSON.stringify(this.toMap());
  }
} 